import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BottomTabBar from "../components/BottomTabBar";

/**
 * 404 / expired-room state. Detects /room/:code paths so we show the
 * friendly "this room expired 👀" copy instead of a generic 404.
 */
export default function NotFound({ kind = "auto" }) {
  const loc = useLocation();
  const isRoom =
    kind === "room" || (kind === "auto" && loc.pathname.startsWith("/room/"));

  const title = isRoom ? "This room expired 👀" : "We lost the vibe.";
  const subtitle = isRoom
    ? "Rooms vanish once both players leave or after a long pause. Spin up a fresh one — takes 5 seconds."
    : "That page isn't here anymore. Maybe try the front door?";

  return (
    <div className="warm-bg min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="card-glow rounded-3xl p-8 sm:p-10 max-w-lg w-full text-center"
          data-testid="not-found-card"
        >
          <div className="text-6xl mb-4" aria-hidden>
            {isRoom ? "💨" : "🫥"}
          </div>
          <h1
            className="font-display italic text-3xl sm:text-4xl text-white leading-[1.05] mb-3"
            data-testid="not-found-title"
          >
            {title}
          </h1>
          <p className="text-sm text-[#C9C7D9] mb-7">{subtitle}</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="btn-gradient rounded-full px-6 py-3 font-bold text-white active:scale-95"
              data-testid="not-found-home"
            >
              {isRoom ? "Start a new room" : "Take me home"}
            </Link>
            <Link
              to="/about"
              className="rounded-full px-6 py-3 font-bold text-white border border-white/15 hover:bg-white/5 transition-colors"
              data-testid="not-found-about"
            >
              How it works
            </Link>
          </div>
        </motion.div>
      </main>
      <Footer />
      <BottomTabBar />
    </div>
  );
}
